// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleI18n } from '@platform/core/types/modularity/IModuleI18n';
import type { IModuleManifest } from '@platform/core/types/modularity/IModuleManifest';

/** Пакет модуля «Позиційні документи» (Position Papers, ключ `ppr`, група `advocacy`). */
export const positionPapersManifest: IModuleManifest = {
  key: 'ppr',
  group: 'advocacy',
  slug: 'position-papers',
  prefix: 'PPR',
  name: { en: 'Position Papers', uk: 'Позиційні документи' },
  entities: [
    { key: 'ppr', slug: 'ppr', name: { en: 'Position Papers', uk: 'Позиційні документи' }, main: true },
    { key: 'position_paper_proposed_wording', slug: 'position-paper-proposed-wording', name: { en: 'Position Paper Proposed Wordings', uk: 'Запропоновані формулювання' }, main: false },
    { key: 'position_paper_evidence', slug: 'position-paper-evidence', name: { en: 'Position Paper Evidences', uk: 'Докази' }, main: false },
    { key: 'position_paper_response', slug: 'position-paper-response', name: { en: 'Position Paper Responses', uk: 'Відповіді' }, main: false },
  ],
  loadState: () => import('./state/positionPapersSlice').then((m) => m.positionPapersSlice),
  loadI18n: (lng) => (lng === 'uk' ? import('./i18n/uk.json') : import('./i18n/en.json')).then((m) => m.default as IModuleI18n),
  loadDefinition: () => import('./definition').then((m) => m.definition),
};
